import React from "react";
import PropTypes from 'prop-types';
import './selectField.scss'
import ReactSelectWithMaterialUi from "./ReactSelectWithMaterialUi";
import _ from './../../../utils/ObjectUtils';

const SelectField =
    ({
         isMulti = false,
         value = isMulti ? [] : "",
         options = [],
         label = "",
         handleFieldChange,
         dataAttribute = "value",
         placeholder,
         error,
         disabled = false,
         isClearable = true,
         isCreatable = false,
         classes = "",
         themeName = "",
         width = 6
     }) => {
        return (
            <div className={"col-lg-" + width + ( width < 6 ? " col-md-6 " : " col-md-12 ") + "select-field " + classes}>
                <ReactSelectWithMaterialUi
                    themeName={themeName}
                    isMulti={isMulti}
                    label={label}
                    options={options}
                    isClearable={isClearable}
                    placeholder={placeholder}
                    error={error}
                    disabled={disabled}
                    isCreatable={isCreatable}
                    handleChange={value => handleFieldChange(
                        value ?
                            isMulti ?
                                value.map(v => v.value) :
                                value.value :
                            null
                    )}
                    singleValue={options.find(option => option[dataAttribute] === value)}
                    multiValue={isMulti && !_.isNilOrEmpty(value) ? findOptionsWithinValueArray(options, value, dataAttribute) : []}
                />
            </div>
        );
    };

function findOptionsWithinValueArray(options, value, dataAttribute) {
    let result = [];
    value.forEach(v => {
        let optionIndex = options.findIndex(o => {
            return o[dataAttribute] === v;
        });
        if (optionIndex !== -1) {
            result.push(options[optionIndex]);
        }
    });
    return result;
}

SelectField.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.array,
        PropTypes.bool
    ]),
    isMulti: PropTypes.bool,
    options: PropTypes.array,
    dataAttribute: PropTypes.string,
    label: PropTypes.string,
    handleFieldChange: PropTypes.func.isRequired,
    error: PropTypes.string,
    false: PropTypes.bool,
};

export default SelectField;